import permissions from '@/enums/permissions';

const ContractTerminationRouter = [
    {
        path: '/baixa-contratos',
        name: 'contract-termination',
        component: () => import('@/views/pages/ContractTermination/ContractTermination.vue'),
        meta: {
            permissions: permissions.contractTermination,
        },
    },
];

export default ContractTerminationRouter;
